import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import IcomoonReact from 'icomoon-react';

import iconSet from '../../../../../shared/images/teambuildr-selection.json';
import { ColorBlack, ColorGreen } from '../../../../../shared/GlobalStyles';

export const ButtonStyled = styled('button')`
  display: flex;
  flex-direction: row;
  font-family: 'Nunito Sans';
  font-size: ${props => (props.large ? '14px' : '12px')};
  font-weight: 900;
  letter-spacing: 1.5px;
  height: ${props => (props.large && '48px')};
  width: ${props => (props.fullWidth ? '100%' : 'auto')};
  background: ${(props) => {
    const isIconOnly = props.isIconOnly ? 'transparent' : props.theme.colorAccent;
    const isCustom = props.customColor ? props.customColor : isIconOnly;
    const isPrimary = props.primary ? isCustom : props.theme.colors.background[1];
    const isDisabled = props.disabled ? '#d3d3d3' : isPrimary;
    return (
      props.complete ? ColorGreen : isDisabled
    );
  }};
  border: ${(props) => {
    const hasNoBorder = props.noBorder || props.iconOnly ? '0px' : `1px solid ${props.theme.colors.noBorderColor}`;
    return (
      props.complete ? `1px solid ${ColorGreen}` : hasNoBorder
    );
  }};
  border-radius: ${(props) => {
    const isRounded = props.rounded ? '4px' : '20px';
    return (
      props.square ? '0px' : isRounded
    );
  }};
  text-transform: uppercase;
  color: ${(props) => {
    const isAccentDarkTheme = props.theme.isAccentDarkTheme ? 'white' : ColorBlack;
    return (
      props.primary || props.complete ? isAccentDarkTheme : props.theme.textColor
    );
  }};
  padding: ${props => (props.iconOnly ? '5px' : '8px 18px')};
  justify-content: center;
  align-self: ${props => (props.bottom ? 'flex-end' : '')};
  align-items: center;
  transition: all 250ms ease-in-out;
  cursor: ${props => (props.disabled ? 'default' : 'pointer')};
  opacity: ${props => (props.disabled ? '.8' : '1')};
  & svg {
    display: ${props => (props.icon ? 'block' : 'none')}!important;
    align-self: center;
    margin-right: ${props => (props.iconOnly ? '0px' : '10px')};
    path {
      transition: all 250ms ease-in-out;
      fill: ${(props) => {
    const isIconOnly = props.iconOnly ? props.theme.colors.lightText[0] : props.theme.textColor;
    return props.complete ? 'rgba(255,255,255)!important' : isIconOnly;
  }}
    }
  }

  /* &:hover {
    background-color: ${props => (props.noHover || props.iconOnly ? '' : props.theme.colorAccent)};
    border: ${(props) => {
    const isNoHover = props.noHover ? `1px solid ${props.theme.colors.noBorderColor}` : `1px solid ${props.theme.colorAccent}`;
    return props.noBorder || props.iconOnly ? '0px' : isNoHover;
  }};
    color: ${(props) => {
    const noHover = props.noHover ? 'black' : 'white';
    return (
      props.theme.isAccentDarkTheme ? noHover : '#444444'
    );
  }};
    transition: all 250ms ease-in-out;
    
    & svg {
      path {
        transition: all 250ms ease-in-out;
        fill: ${(props) => {
    const isIconOnly = props.iconOnly ? props.theme.colors.lightText[0] : 'rgb(255,255,255)!important';
    return (props.theme.isAccentDarkTheme ? isIconOnly : 'rgb(68,68,68)!important');
  }};
      }
    }
  } */
`;

const Icon = styled('img')`
  height: 20px;
  margin-right: 20px;
`;

const Button = ({
  bottom,
  buttonRef,
  cta,
  className,
  complete,
  customColor,
  customIcon,
  disabled,
  fullWidth,
  id,
  icon,
  iconOnly,
  large,
  name,
  noBorder,
  noHover,
  onClick,
  primary,
  rounded,
  square,
  type,
}) => (
  <ButtonStyled
    bottom={bottom}
    className={className}
    complete={complete}
    customColor={customColor}
    disabled={disabled}
    fullWidth={fullWidth}
    icon={icon}
    iconOnly={iconOnly}
    large={large}
    name={name}
    id={id}
    noBorder={noBorder}
    noHover={noHover}
    onClick={onClick}
    primary={primary}
    ref={buttonRef}
    rounded={rounded}
    square={square}
    type={type}
  >
    {customIcon ? (
      <Icon className='fluid' src={customIcon} alt='button' />
    ) : (
      icon && (
        <IcomoonReact
          iconSet={iconSet}
          size={15}
          icon={icon && icon}
        />
      )
    )}
    {cta}
  </ButtonStyled>
);

Button.propTypes = {
  bottom: PropTypes.bool,
  buttonRef: PropTypes.instanceOf(Object),
  className: PropTypes.string,
  customColor: PropTypes.string,
  customIcon: PropTypes.string,
  complete: PropTypes.bool,
  disabled: PropTypes.bool,
  cta: PropTypes.string,
  fullWidth: PropTypes.bool,
  icon: PropTypes.string,
  iconOnly: PropTypes.bool,
  large: PropTypes.bool,
  name: PropTypes.string,
  id: PropTypes.string,
  noBorder: PropTypes.bool,
  noHover: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  primary: PropTypes.bool,
  rounded: PropTypes.bool,
  square: PropTypes.bool,
};

Button.defaultProps = {
  bottom: false,
  buttonRef: {},
  className: '',
  cta: '',
  customColor: null,
  customIcon: null,
  complete: false,
  disabled: false,
  fullWidth: false,
  icon: '',
  iconOnly: false,
  large: false,
  name: null,
  id: null,
  noBorder: false,
  noHover: false,
  primary: false,
  rounded: false,
  square: false,
};

export default Button;
